import "./modules/global";
import CreateCustomSelect from "./modules/custom-select";
import { ShowElement, HideElement } from "./modules/utils";

window.addEventListener("load", () => {
	const filtersSelects = document.querySelectorAll(".wiring-filters select");
	filtersSelects.forEach((select) => {
		new CreateCustomSelect(select);
		const custom = select.nextElementSibling;
		const toggle = custom?.querySelector(".option--selected");
		// Fallback toggle if global data-togle handler is not picked up
		toggle &&
			toggle.addEventListener("click", () => {
				custom.classList.toggle("show");
			});
	});

	// Safety: delegate toggle for custom selects in the wiring filters
	document.addEventListener("click", (e) => {
		const toggle = e.target.closest(
			".wiring-filters .custom-select .option--selected"
		);
		if (!toggle) return;
		const custom = toggle.closest(".custom-select");
		custom && custom.classList.toggle("show");
	});

	// Show search results table when search is triggered
	const searchButton = document.querySelector(".wiring-filters__submit");
	const resetButton = document.querySelector(".wiring-filters__reset");
	const searchResults = document.querySelector(".wiring-search-results");
	if (searchButton && searchResults) {
		searchResults.classList.remove("is-visible");
		searchButton.addEventListener("click", (e) => {
			e.preventDefault();
			searchResults.classList.add("is-visible");
		});
		if (resetButton && searchResults) {
			resetButton.addEventListener("click", (e) => {
				e.preventDefault();
				searchResults.classList.remove("is-visible");
			});
		}
	}

	// Helper function to open a modal
	function openModal(modal) {
		if (modal) {
			modal.classList.add("show");
			document.body.classList.add("overflow");
		}
	}

	// Helper function to close a modal
	function closeModal(modal) {
		if (modal) {
			modal.classList.remove("show");
			document.body.classList.remove("overflow");
		}
	}

	// VIN Decode Modal
	const decodeVinTrigger = document.getElementById("decode-vin-trigger");
	const vinDecodeModal = document.getElementById("vin-decode-modal");

	// Wiring Diagram Request Modal
	const wiringDiagramRequestTrigger = document.getElementById(
		"wiring-diagram-request-trigger"
	);
	const wiringDiagramRequestModal = document.getElementById(
		"wiring-diagram-request-modal"
	);

	// Wiring Diagram Submission Modal (Multi-step)
	const submitWiringDiagramTrigger = document.getElementById(
		"submit-wiring-diagram-trigger"
	);
	const submitWiringDiagramModal = document.getElementById(
		"submit-wiring-diagram-modal"
	);

	// VIN Decode Modal handlers
	if (decodeVinTrigger && vinDecodeModal) {
		// Open modal when clicking "decode VIN"
		decodeVinTrigger.addEventListener("click", (e) => {
			e.preventDefault();
			openModal(vinDecodeModal);
		});

		// Close modal when clicking close button
		const vinCloseButtons = document.querySelectorAll(
			'[data-close="#vin-decode-modal"]'
		);
		vinCloseButtons.forEach((btn) => {
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				closeModal(vinDecodeModal);
			});
		});

		// Close modal when clicking outside the modal content
		vinDecodeModal.addEventListener("click", (e) => {
			if (e.target === vinDecodeModal) {
				closeModal(vinDecodeModal);
			}
		});
	}

	// Wiring Diagram Request Modal handlers
	if (wiringDiagramRequestTrigger && wiringDiagramRequestModal) {
		// Open modal when clicking "Request wiring diagram"
		wiringDiagramRequestTrigger.addEventListener("click", (e) => {
			e.preventDefault();
			openModal(wiringDiagramRequestModal);
		});

		// Close modal when clicking close button
		const requestCloseButtons = document.querySelectorAll(
			'[data-close="#wiring-diagram-request-modal"]'
		);
		requestCloseButtons.forEach((btn) => {
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				closeModal(wiringDiagramRequestModal);
			});
		});

		// Close modal when clicking outside the modal content
		wiringDiagramRequestModal.addEventListener("click", (e) => {
			if (e.target === wiringDiagramRequestModal) {
				closeModal(wiringDiagramRequestModal);
			}
		});
	}

	// Close any open modal on Escape key
	document.addEventListener("keydown", (e) => {
		if (e.key === "Escape") {
			if (vinDecodeModal && vinDecodeModal.classList.contains("show")) {
				closeModal(vinDecodeModal);
			}
			if (
				wiringDiagramRequestModal &&
				wiringDiagramRequestModal.classList.contains("show")
			) {
				closeModal(wiringDiagramRequestModal);
			}
			if (
				submitWiringDiagramModal &&
				submitWiringDiagramModal.classList.contains("show")
			) {
				closeModal(submitWiringDiagramModal);
			}
		}
	});

	const submissionSteps = document.querySelectorAll(".submission-step");
	const submissionBackBtn = document.getElementById("submission-back-btn");
	const submissionNextBtn = document.getElementById("submission-next-btn");
	const progressStepText = document.querySelector(
		".submission-progress__step .current-step"
	);
	const progressLabel = document.querySelector(".submission-progress__label");
	const progressBars = document.querySelectorAll(".submission-progress__bar");

	let currentStep = 1;
	const totalSteps = 6;
	const stepLabels = [
		"",
		"- Vehicle information",
		"- Diagram details",
		"- Technical notices",
		"- Step 4",
		"- Step 5",
		"- Step 6",
	];

	// Function to update progress indicator
	function updateProgress(step) {
		if (progressStepText) {
			progressStepText.textContent = step;
		}
		if (progressLabel && stepLabels[step]) {
			progressLabel.textContent = stepLabels[step];
		}

		// Update progress bars
		progressBars.forEach((bar, index) => {
			if (index < step) {
				bar.classList.add("submission-progress__bar--active");
				bar.classList.add("submission-progress__bar--completed");
			} else {
				bar.classList.remove("submission-progress__bar--active");
				bar.classList.remove("submission-progress__bar--completed");
			}
		});
	}

	// Function to show specific step
	function showStep(step) {
		submissionSteps.forEach((stepEl, index) => {
			if (index + 1 === step) {
				stepEl.classList.add("submission-step--active");
			} else {
				stepEl.classList.remove("submission-step--active");
			}
		});

		// Show/hide back button
		if (submissionBackBtn) {
			submissionBackBtn.style.display = step > 1 ? "flex" : "none";
		}

		// Update next button text for last step
		if (submissionNextBtn) {
			if (step === totalSteps) {
				submissionNextBtn.textContent = "Submit";
			} else {
				const arrowSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M6 4L10 8L6 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>`;
				submissionNextBtn.innerHTML = `Next step ${arrowSvg}`;
			}
		}

		updateProgress(step);
	}

	// Function to reset modal to first step
	function resetSubmissionModal() {
		currentStep = 1;
		showStep(1);
	}

	if (submitWiringDiagramTrigger && submitWiringDiagramModal) {
		// Initialize custom selects for submission modal when modal opens
		function initializeSubmissionSelects() {
			const submissionSelects =
				submitWiringDiagramModal.querySelectorAll("select");
			submissionSelects.forEach((select) => {
				// Only initialize if not already initialized
				if (!select.nextElementSibling?.classList.contains("custom-select")) {
					new CreateCustomSelect(select);
				}
			});
		}

		// Open modal when clicking "Submit wiring diagram"
		submitWiringDiagramTrigger.addEventListener("click", (e) => {
			e.preventDefault();
			resetSubmissionModal();
			initializeSubmissionSelects();
			openModal(submitWiringDiagramModal);
		});

		// Close modal when clicking close button
		const submitCloseButtons = document.querySelectorAll(
			'[data-close="#submit-wiring-diagram-modal"]'
		);
		submitCloseButtons.forEach((btn) => {
			btn.addEventListener("click", (e) => {
				e.preventDefault();
				resetSubmissionModal();
				closeModal(submitWiringDiagramModal);
			});
		});

		// Close modal when clicking outside
		submitWiringDiagramModal.addEventListener("click", (e) => {
			if (e.target === submitWiringDiagramModal) {
				resetSubmissionModal();
				closeModal(submitWiringDiagramModal);
			}
		});

		// Next button handler
		if (submissionNextBtn) {
			submissionNextBtn.addEventListener("click", (e) => {
				e.preventDefault();
				if (currentStep < totalSteps) {
					currentStep++;
					showStep(currentStep);
				} else {
					// Handle final submission
					console.log("Submitting form...");
					// Add your submission logic here
				}
			});
		}

		// Back button handler
		if (submissionBackBtn) {
			submissionBackBtn.addEventListener("click", (e) => {
				e.preventDefault();
				if (currentStep > 1) {
					currentStep--;
					showStep(currentStep);
				}
			});
		}
	}
});
